import { AxiosResponse } from "axios"
import { call, select, takeLatest } from "redux-saga/effects"
import { AppService } from "src/services/app"
import { getBaseUrl } from "../selectors/features/app"
import { RequestTypes } from "../types"

const appservice = new AppService()

function* getRecentBulkSendsSaga(action: any) {
  const { payload } = action
  const { id } = payload
  try {
    const baseUrl: string = yield select(getBaseUrl)
    const response: AxiosResponse<any> = yield call(appservice.getRecentBulkSends, baseUrl, id)
    payload?.cbSuccess && payload?.cbSuccess({ ...response })
  } catch (error: any) {
    payload?.cbFailure && payload?.cbFailure(error?.statusText || "recent sends failed")
  }
}

export function* watchGetRecentBulkSends() {
  yield takeLatest(RequestTypes.GET_RECENT_BULK_SENDS, getRecentBulkSendsSaga)
}
